function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Fasting from 'svg/mobileReports/fasting.svg';
import PreMeal from 'svg/mobileReports/pre-meal.svg';
import PostMeal from 'svg/mobileReports/post-meal.svg';
var _React_PureComponent;
class ReadingFlagIcon extends (_React_PureComponent = React.PureComponent) {
    getIcon(flag) {
        switch(flag){
            case 'Fasting':
                return Fasting;
            case 'PreMeal':
                return PreMeal;
            case 'PostMeal':
                return PostMeal;
            default:
                return null;
        }
    }
    render() {
        const { flag, className } = this.props;
        const Icon = this.getIcon(flag);
        return Icon && /*#__PURE__*/ _jsx(Icon, {
            className: className
        });
    }
}
_define_property(ReadingFlagIcon, "propTypes", {
    flag: PropTypes.oneOf([
        'All',
        'Fasting',
        'PreMeal',
        'PostMeal',
        'Logbook',
        'None'
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
export default ReadingFlagIcon;
